import { Button } from "reactstrap";
import FooterComponent from "../Footer/footer.component";
import HeaderComponent from "../Header/header.component";
import "./bom-tool.styles.css";
import { Check, X } from "lucide-react";

const BomToolTemplate = ({
  templateModal: {
    bomData,
    totalParts,
    inStockCount,
    noStockCount,
    alternativeCount,
    activeFilters,
    filteredData,
    partialCount,
    editingPartNumber,
    bomDetail,
    selectAll,
    selectedItems,
  },
  templateEvents: {
    handleAddToCart,
    getMatchedPrice,
    getExtendedPrice,
    setFilter,
    handleFilterChange,
    handleExportBomTable,
    handlePartNumberChange,
    handlePartNumberKeyDown,
    handlePartNumberSubmit,
    handlePartNumberCancel,
    handleAddSelectedToCart,
    handleSelectItem,
    handleSelectAll,
  },
}) => {
  return (
    <>
      {/* <HeaderComponent /> */}
      {/* <section className="page-navtab-content page-bg py-4"> */}
      <div className="container-fluid">
        <div className="mt-3 d-flex justify-content-center">
          <h3 className="mb-3 fw-semibold text-primary">Bom Result</h3>
        </div>
        <div className="container-fluid px-0 mb-3">
          <div className="row g-2">
            <div className="col-12 col-lg-9">
              <div className="d-flex flex-wrap gap-2">
                <button
                  className={`btn btn-filter btn-outline-primary flex-grow-1 flex-sm-grow-0 ${
                    activeFilters.includes("all") ? "active" : ""
                  }`}
                  onClick={(e) => handleFilterChange("all", e)}
                >
                  All Parts ({totalParts})
                </button>

                <button
                  className={`btn btn-filter btn-outline-primary flex-grow-1 flex-sm-grow-0 ${
                    activeFilters.includes("inStock") ? "active" : ""
                  }`}
                  onClick={(e) => handleFilterChange("inStock", e)}
                >
                  In Stock ({inStockCount})
                </button>

                <button
                  className={`btn btn-filter btn-outline-primary flex-grow-1 flex-sm-grow-0 ${
                    activeFilters.includes("noStock") ? "active" : ""
                  }`}
                  onClick={(e) => handleFilterChange("noStock", e)}
                >
                  No Stock ({noStockCount})
                </button>

                <button
                  className={`btn btn-filter btn-outline-primary flex-grow-1 flex-sm-grow-0 ${
                    activeFilters.includes("partialCount") ? "active" : ""
                  }`}
                  onClick={(e) => handleFilterChange("partialCount", e)}
                >
                  Partial Stock ({partialCount})
                </button>

                <button
                  className={`btn btn-filter btn-outline-primary flex-grow-1 flex-sm-grow-0 ${
                    activeFilters.includes("alternative") ? "active" : ""
                  }`}
                  onClick={(e) => handleFilterChange("alternative", e)}
                >
                  Alternatives ({alternativeCount})
                </button>
                <div className="">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleAddSelectedToCart}
                    disabled={
                      !Object.values(selectedItems).some((selected) => selected)
                    }
                  >
                    <i className="fas fa-cart-plus me-2"></i>
                    Add Selected to Cart (
                    {Object.values(selectedItems).filter(Boolean).length})
                  </button>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-3 text-lg-end">
              <button
                onClick={handleExportBomTable}
                className="btn btn-generate-quote"
              >
                Generate Quote
              </button>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="container-fluid  p-2 bg-light">
              <div className="card-body">
                <form method="POST">
                  <div className="">
                    <div className="table-responsive">
                      <table className="bom-table">
                        <thead className="table-light text-a-center">
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={(e) =>
                                  handleSelectAll(e.target.checked)
                                }
                                className="form-check-input"
                              />
                            </th>
                            <th>S.NO</th>
                            <th>Part Number</th>
                            <th>QTY</th>
                            <th>Part Match</th>
                            <th>Quoted MPN</th>
                            <th>Manufacturer</th>
                            <th className="bom-description">Description</th>
                            <th>Availability</th>
                            <th>Min/Mul</th>
                            <th>Suggested Quantity</th>
                            <th>Lead Time</th>
                            <th>
                              <span>Unit Price (INR)</span>
                            </th>
                            <th>Ext.Price (INR)</th>
                            <th>Add To Cart</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData?.length > 0 ? (
                            filteredData?.map((row, index) => {
                              const hasExactMatch = !!row.inventory_match;
                              const hasAlternative = !!row.alternative_match;
                              const isAlternative =
                                !hasExactMatch && hasAlternative;

                              // Pick matched record
                              const match = hasExactMatch
                                ? row.inventory_match
                                : hasAlternative
                                  ? row.alternative_match
                                  : null;

                              // No match case
                              if (!match) {
                                return (
                                  <tr key={row.id} className="bg-red-100">
                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={!!selectedItems[row.id]}
                                        onChange={(e) =>
                                          handleSelectItem(
                                            row.id,
                                            e.target.checked,
                                          )
                                        }
                                        className="form-check-input"
                                      />
                                    </td>
                                    <td className="text-nowrap">{index + 1}</td>
                                    <td className="partNumber-column">
                                      <div className="part-edit-inline">
                                        <input
                                          type="text"
                                          className="input-text"
                                          value={
                                            editingPartNumber[row.id] !==
                                            undefined
                                              ? editingPartNumber[row.id]
                                              : row.part_number
                                          }
                                          onChange={(e) =>
                                            handlePartNumberChange(
                                              row.id,
                                              e.target.value,
                                              row.part_number,
                                            )
                                          }
                                          onKeyDown={(e) =>
                                            handlePartNumberKeyDown(e, row)
                                          }
                                        />

                                        {editingPartNumber[row.id] !==
                                          undefined &&
                                          editingPartNumber[row.id] !==
                                            row.part_number && (
                                            <div className="part-edit-actions">
                                              <button
                                                type="button"
                                                className="tick-button"
                                                onClick={() =>
                                                  handlePartNumberSubmit(row)
                                                }
                                              >
                                                <Check />
                                              </button>

                                              <button
                                                type="button"
                                                className="cross-button"
                                                onClick={() =>
                                                  handlePartNumberCancel(
                                                    row.id,
                                                    row,
                                                  )
                                                }
                                              >
                                                <X />
                                              </button>
                                            </div>
                                          )}
                                      </div>
                                    </td>

                                    <td className="text-nowrap">{row.qty}</td>
                                    <td className="text-nowrap">
                                      <span className="status-badge status-no-match">
                                        No Match
                                      </span>
                                    </td>
                                    <td colSpan={10} className="text-danger">
                                      No matching inventory found
                                    </td>
                                  </tr>
                                );
                              }

                              // Get min & mul qty from API response
                              const minQty = parseInt(match.min_qty || 10, 10);
                              const mulQty = parseInt(match.mul_qty || 10, 10);
                              const requestedQty = parseInt(row.qty || 10, 10);

                              // Calculate supply quantity
                              let supplyQty =
                                Math.ceil(requestedQty / mulQty) * mulQty;
                              if (supplyQty < minQty) {
                                supplyQty = minQty;
                              }

                              return (
                                <tr
                                  key={row.id}
                                  className={
                                    isAlternative ? "bg-yellow-100" : ""
                                  }
                                >
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={!!selectedItems[row.id]}
                                      onChange={(e) =>
                                        handleSelectItem(
                                          row.id,
                                          e.target.checked,
                                        )
                                      }
                                      className="form-check-input"
                                    />
                                  </td>
                                  <td>{index + 1}</td>
                                  <td className="partNumber-column">
                                    <div className="part-edit-inline">
                                      <input
                                        type="text"
                                        className="input-text"
                                        value={
                                          editingPartNumber[row.id] !==
                                          undefined
                                            ? editingPartNumber[row.id]
                                            : row.part_number
                                        }
                                        onChange={(e) =>
                                          handlePartNumberChange(
                                            row.id,
                                            e.target.value,
                                            row.part_number,
                                          )
                                        }
                                        onKeyDown={(e) =>
                                          handlePartNumberKeyDown(e, row)
                                        }
                                      />

                                      {editingPartNumber[row.id] !==
                                        undefined &&
                                        editingPartNumber[row.id] !==
                                          row.part_number && (
                                          <div className="part-edit-actions">
                                            <button
                                              type="button"
                                              className="tick-button"
                                              onClick={() =>
                                                handlePartNumberSubmit(row)
                                              }
                                            >
                                              <Check />
                                            </button>

                                            <button
                                              type="button"
                                              className="cross-button"
                                              onClick={() =>
                                                handlePartNumberCancel(
                                                  row.id,
                                                  row,
                                                )
                                              }
                                            >
                                              <X />
                                            </button>
                                          </div>
                                        )}
                                    </div>
                                  </td>

                                  <td>{row.qty}</td>
                                  <td>
                                    <span
                                      className={`status-badge ${
                                        hasExactMatch
                                          ? "status-in-stock"
                                          : "status-alternative"
                                      }`}
                                    >
                                      {hasExactMatch ? "Exact" : "Alternative"}
                                    </span>
                                  </td>
                                  <td>{match?.part_number || "-"}</td>
                                  <td>{match?.make || "-"}</td>
                                  {/* <td>{match?.mpq || "-"}</td> */}
                                  <td>{match?.description || "-"}</td>
                                  <td>
                                    {match?.available_qty > 0 && (
                                      <>
                                        {match?.available_qty}
                                        <br />
                                      </>
                                    )}

                                    {match?.available_qty > 10 && (
                                      <>Lead Time - Stock</>
                                    )}

                                    {match?.available_qty > 10 &&
                                      match?.partner_available_qty > 10 && (
                                        <>
                                          <br />
                                          <hr />
                                        </>
                                      )}

                                    {match?.partner_available_qty > 0 && (
                                      <>
                                        {match?.partner_available_qty}
                                        <br />
                                      </>
                                    )}

                                    {match?.partner_available_qty > 10 && (
                                      <>Lead Time - 8 Days</>
                                    )}
                                  </td>

                                  {/* Min/Mul column */}
                                  <td>{`${minQty} / ${mulQty}`}</td>

                                  {/* Quantity column */}
                                  <td>
                                    {supplyQty <= (match?.available_qty ?? 0)
                                      ? (match?.available_qty ?? 0)
                                      : supplyQty >
                                          (match?.partner_available_qty ?? 0)
                                        ? (match?.partner_available_qty ?? 0)
                                        : supplyQty}
                                  </td>
                                  <td>{match?.lead_time || "-"}</td>
                                  <td className="text-end">
                                    {match?.price?.length > 0
                                      ? getMatchedPrice(match.price, supplyQty)
                                      : "No price"}
                                  </td>
                                  <td className="text-end">
                                    {match?.price?.length > 0
                                      ? getExtendedPrice(match.price, supplyQty)
                                      : "No price"}
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleAddToCart({
                                          ...row,
                                          qty:
                                            supplyQty <=
                                            (match?.available_qty ?? 0)
                                              ? (match?.available_qty ?? 0)
                                              : supplyQty >
                                                  (match?.partner_available_qty ??
                                                    0)
                                                ? (match?.partner_available_qty ??
                                                  0)
                                                : supplyQty,
                                        })
                                      }
                                      className="btn btn-primary btn-add-to-cart"
                                    >
                                      Add To Cart
                                    </button>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={15} style={{ textAlign: "center" }}>
                                No BOM data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </section> */}

      {/* <FooterComponent /> */}
    </>
  );
};
export default BomToolTemplate;
